import { useSettingsDispatch } from "../context/SettingsProvider";

import { fetchData } from "../inc/functions";
import { SET_USER } from "../inc/endpoints"

export default function useAsyncDispatchUser(userContext, userDispatch) {

	const settingsDispatch = useSettingsDispatch();

	return (action) => {
		switch (action.type) {
			case 'set': {
				
				settingsDispatch({
					type: 'isLoading',
					isLoading: true
				});

				const params = {
					...action.user
				};

				const options = {
					method: 'POST',
					blocking: true,
					credentials: "include",
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(params),
				}
				
				fetchData(`${SET_USER}`, options)
					.then(data => {
						if(data.status === 'OK'){

							userDispatch({
								type: 'update',
								user: params
							});

							settingsDispatch({
								type: 'update', 
								payload: {
									isLoading: false,
									isFormExpanded: false
								}
							})
						}
					})
				break;
			}
			default: {
				throw Error('Unknown async user action: ' + action.type);
			}
		}
	}
};